import { stats } from '@fiverr-private/obs';
import main from '../../src/main';
import { initEventListeners } from '../../src/eventListeners';

initEventListeners();
main();
stats.count('business_support_chat', 'impression.script');
